module.exports = __webpack_public_path__ + "static/zap-v2.d4c3f016.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/zap-v2.png
// module id = 525
// module chunks = 195351340454287